import { Tag } from "antd";
export const DefaultTag = ({ icon, text = null, ...restProps }) => {
  return (
    <Tag color="default" {...restProps}>
      {icon} {text === null ? "Pendiente" : text}
    </Tag>
  );
};
